import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppService, BASE_URL_SSO, REALM } from '../app.service';


@Injectable()
export class AuthenticationService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  login(username: string, password: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/login-tcel`;
    return this.postLogin(this.endpoint, { username: username, password: password, realm: REALM });
  }

  selectCommunity(communityId, token): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/community/set`;
    return this.post(this.endpoint, { community_id: communityId });
  }

  selectCommunityTCEL(propertyId, communityId, token): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/community/tcel-set`;
    return this.post(this.endpoint, { community_id: communityId, property_id: propertyId });
  }

  check(token: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/check`;
    return this.get(this.endpoint, 'text');
  }

  reset(username: string, app?: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/reset`;
    return this.post(this.endpoint, { username: username, realm: REALM, app, reset: true });
  }

  restore(username: string, password: string, token: string): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/reset/${token}`;
    return this.post(this.endpoint, { username: username, password: password, realm: REALM }, 'text');
  }

  logout(token: string): Observable<any> {
    // remove user from local storage to log user out
    this.endpoint = `${BASE_URL_SSO}/logout`;
    return this.get(this.endpoint);
  }

  getDomain(url) {
    const hostName = this.getHostName(url);
    let domain = hostName;

    if (hostName != null) {
      const parts = hostName.split('.').reverse();
      if (parts != null && parts.length > 1) {
          domain = parts[1] + '.' + parts[0];

          if (hostName.toLowerCase().indexOf('.co.uk') !== -1 && parts.length > 2) {
            domain = parts[2] + '.' + domain;
          }
      }
    }
    return domain;
  }

  getHostName(url) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
      return match[2];
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts